// extracted by mini-css-extract-plugin
export default {"clock":"Login_clock__Q7Ats","clockTime":"Login_clockTime__zGL8w","clockDate":"Login_clockDate__aLlHu","blink":"Login_blink__bkYC2"};